import { TextBlockSkeleton } from "../skeletonTemplates/skeletons";

interface props {
    text: string;
    skeleton?: boolean;
}

const Description = ({ text, skeleton }: props): JSX.Element => {
    if (skeleton) return <DescriptionSkeleton />
    return (
        <div className="flex flex-col gap-1">
            <h3>Description</h3>
            <span className="text-gray-400 text-sm">
                {text}
            </span>
        </div>
    )
}

export default Description

export const DescriptionSkeleton = (): JSX.Element => {
    return (
        <div className="flex flex-col gap-1">
            <h3>Description</h3>
            <TextBlockSkeleton />
        </div>
    )
}